import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import FlowStudio from './components/FlowStudio';
import PDFOCRDemo from './components/PDFOCRDemo';
import NodeTesting from './components/NodeTesting';
import EmbedTester from './components/EmbedTester';
import AuthGuard from './components/AuthGuard';
import AuthCallback from './components/AuthCallback';
import EmbedPage from './components/EmbedPage';
import SupportChat from './components/SupportChat';
import PropertiesList from './components/PropertiesList';
import StefanoPage from './components/StefanoPage';
import { FLOW_NEXT_ENABLED } from './config';

// Nuovo editor flow (packages/flow-*): caricato lazy solo se il flag è attivo,
// così non pesa sul bundle principale né tocca il vecchio FlowStudio.
const FlowNextPage = lazy(() => import('./components/FlowNextPage'));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* 🔐 Callback Auth0 - gestisce il redirect dopo login */}
        <Route path="/callback" element={<AuthCallback />} />
        
        {/* Pagina principale (protetta da AuthGuard - solo enterprise) */}
        <Route 
          path="/" 
          element={
            <AuthGuard>
              <FlowStudio />
            </AuthGuard>
          } 
        />
        
        {/* Pagina demo PDF OCR (PUBBLICA - accessibile senza login!) */}
        <Route path="/pdf" element={<PDFOCRDemo />} />

        {/* Pagina embed widget (PUBBLICA - per inclusione in siti esterni) */}
        <Route path="/embed" element={<EmbedPage />} />

        {/* Pagina testing nodi (protetta da AuthGuard) */}
        <Route
          path="/node-testing"
          element={
            <AuthGuard>
              <NodeTesting />
            </AuthGuard>
          }
        />

        {/* Pagina test embed widget (protetta da AuthGuard) */}
        <Route
          path="/embed-tester"
          element={
            <AuthGuard>
              <EmbedTester />
            </AuthGuard>
          }
        />

        {/* Pagina lista immobili (PUBBLICA - accessibile senza login!) */}
        <Route path="/properties" element={<PropertiesList />} />

        {/* Pagina Stefano De Sanctis - Chat AI su podcast counseling (PUBBLICA) */}
        <Route path="/stefano" element={<StefanoPage />} />

        {/* 🧪 Nuovo editor flow (dietro feature-flag VITE_FLOW_NEXT) */}
        <Route
          path="/flow-next"
          element={
            FLOW_NEXT_ENABLED ? (
              <AuthGuard>
                <Suspense fallback={<div style={{ padding: 24 }}>Caricamento editor…</div>}>
                  <FlowNextPage />
                </Suspense>
              </AuthGuard>
            ) : (
              <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
                <h2>Flow Next disattivato</h2>
                <p>
                  Imposta <code>VITE_FLOW_NEXT=true</code> e riavvia il dev server per
                  abilitare il nuovo editor.
                </p>
              </div>
            )
          }
        />

        {/* ⚠️ TEMPORANEA — anteprima editor SENZA AuthGuard (solo dietro flag).
            Da rimuovere prima della produzione. */}
        {FLOW_NEXT_ENABLED && (
          <Route
            path="/flow-next-dev"
            element={
              <Suspense fallback={<div style={{ padding: 24 }}>Caricamento editor…</div>}>
                <FlowNextPage />
              </Suspense>
            }
          />
        )}
      </Routes>
      
      {/* 💬 Chat di supporto (sempre visibile, solo se autenticati) */}
      <SupportChat />
    </BrowserRouter>
  );
}

export default App;

